export enum SERVER_URLS {
  /** Dev */
  apiDev = 'https://172.24.32.4',
  apiPortDev = 0,
  identityDev = 'https://172.24.32.4',
  identityPortDev = 9001,

  /** Qa */
  apiQa = 'https://172.24.34.4',
  apiPortQa = 0,
  identityQa = 'https://172.24.34.4',
  identityPortQa = 9001,

  /** Uat */
  apiUat = 'https://172.24.36.4',
  apiPortUat = 0,
  identityUat = 'https://172.24.36.4',
  identityPortUat = 9001,

  /** Prod */

  apiProd = 'https://172.24.20.21',
  apiPortProd = 0,
  identityProd = 'https://auth.proquifa.com.mx',
  identityPortProd = 9000,

}
